__turbopack_context__.v({
  "caption": "HeroSection-module__-iDqqG__caption",
  "containerRoot": "HeroSection-module__-iDqqG__containerRoot",
});
